const MapAnalytics = ( function(){

    // Add an event to Google Analytics
    const addAnalyticsEvent = function( parameters , event = 'map' )
    {
        // Analytics hasn't loaded yet
        if( typeof gtag === 'undefined' )
        {
            return false;
        }

        gtag( 'event' , event , parameters );
    };

    return {
        addAnalyticsEvent
    };
}());

export default MapAnalytics;
